// src/lib/getSignedViewUrl.ts
import { supabase } from './supabase';

export type SignedUrlInfo = { url: string; expiresAt: number };

export const getSignedViewUrl = async (imagePath: string): Promise<SignedUrlInfo> => {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  
  // Get fresh session token and refresh if needed
  let { data: { session } } = await supabase.auth.getSession();
  
  if (!session?.access_token) {
    throw new Error('No valid session found');
  }
  
  // Try to refresh the session if it might be expired
  try {
    const { data: { session: refreshedSession } } = await supabase.auth.refreshSession();
    if (refreshedSession?.access_token) {
      session = refreshedSession;
    }
  } catch (refreshError) {
    console.warn('Failed to refresh session, using existing:', refreshError);
  }
  
  const res = await fetch(`${supabaseUrl}/functions/v1/get-car-image-view-url`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`
    },
    body: JSON.stringify({ path: imagePath }),
  });

  if (!res.ok) {
    const errorText = await res.text();
    console.error('Edge function error response:', res.status, errorText);
    throw new Error(`Failed to get signed view URL: ${errorText}`);
  }
  
  return await res.json(); // { url, expiresAt }
};
